const CommonRoutes = {
  menu: '/menu',
  search: '/search',
  notFound: '/404',
  forbidden: '/forbidden',
};

export default CommonRoutes;
